/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/no-unknown-property */
import React, { useMemo } from 'react';
import { IconButton } from '@pypestream/design-system';
import { observer } from 'mobx-react-lite';
import { runInAction } from 'mobx';
// import { toJS } from 'mobx';

import {
  sendProStudioEvent,
  useProStudioCtxSelector,
} from '../../../xstate/app.xstate';
import { NodeColumns, tableStore } from '../../../stores/table-store';
import { getJsonOrderMap } from '../utils';
import { CsvUploader } from '../csv-uploader';
import { CsvDownloader } from '../csv-downloader';

import './controls-bar.scss';

// function isColumnId(
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   data: any
// ): data is keyof typeof NodeColumns {
//   // console.log('data', data, Object.keys(TableNode), data in Object.keys(TableNode));
//   return (data && data in NodeColumns) || false;
// }

// function canRenderColumnValue(
//   columnId: keyof typeof NodeColumns | undefined
// ): boolean {
//   if (columnId !== 'behaviors' && columnId !== 'parameterInput') return true;

//   return false;
// }

const convertNextNodesToArray = (value: string): (string | number)[] => {
  return value
    .split(',')
    .map((n) => (Number.isFinite(Number(n)) ? Number(n) : n));
};

export const ControlsBar: React.FC<{
  openSupervisorPanel: () => void;
  supervisorPanelOpen: boolean;
  children?: React.ReactNode;
}> = observer(({ openSupervisorPanel, supervisorPanelOpen, children }) => {
  // const [selectedCellContent, setSelectedCellContent] = useState('');
  // const [columnId, setSelectedCellId] = useState<keyof typeof NodeColumns>();
  // const [selectedRowId, setSelectedRowId] = useState('');

  const valueToRender = tableStore.selectedCellValue();
  const rowId = tableStore.selectedRowId();
  const columnId = tableStore.selectedCell()?.columnId;
  const isJsonColumn = tableStore.isJsonColumn(rowId, columnId);
  const [originalValueOnFocus, setOriginalValueOnFocus] = React.useState<
    string | undefined
  >(undefined);

  const { draftVersionSolutionData } = useProStudioCtxSelector((ctx) => ({
    draftVersionSolutionData: ctx.draftVersionSolutionData,
  }));

  const isSupervisorConfigured = useMemo(
    () => draftVersionSolutionData?.llmCredential?.llmProviderId,
    [draftVersionSolutionData]
  );

  // console.log('valueToRender', valueToRender);

  // const inputRef = useRef<HTMLTextAreaElement>(null);

  // if (tableStore.selectedCells.size === 1) {
  //   tableStore.selectedCells.forEach((cell) => {
  //     const lastIndex = cell.lastIndexOf('-');
  //     const rowId = cell.substr(0, lastIndex);
  //     const columnIdParsed = cell.substr(lastIndex).replace('-', '');
  //     console.log('isColumnId', isColumnId(columnIdParsed), columnId);

  //     if (!columnIdParsed) return;

  //     if (columnIdParsed && isColumnId(columnIdParsed)) {
  //       if (rowId !== selectedRowId) {
  //         setSelectedRowId(rowId);
  //       }

  //       console.log(columnIdParsed, columnId);
  //       if (columnIdParsed && columnIdParsed !== columnId) {
  //         setSelectedCellId(columnIdParsed);
  //       }

  //       const row = tableStore.rows.find((row2) => row2.id === rowId);
  //       const cellValue = row?.[columnIdParsed];

  //       console.log('cellValue', cellValue);

  //       if (
  //         cellValue &&
  //         selectedCellContent !== cellValue &&
  //         canRenderColumnValue(columnIdParsed)
  //       ) {
  //         // console.log('setSelectedCellContent - first', cellValue);
  //         setSelectedCellContent(cellValue);

  //         if (inputRef.current) {
  //           inputRef.current.value = cellValue;
  //         }

  //         // if (cellValue === '')
  //       } else if (
  //         !canRenderColumnValue(columnIdParsed) ||
  //         !cellValue ||
  //         cellValue === ''
  //       ) {
  //         // if (cellValue !== selectedCellContent) {
  //         // setSelectedCellContent('');
  //         setSelectedCellContent('');

  //         if (inputRef.current) {
  //           inputRef.current.value = '';
  //         }
  //         // }
  //       }
  //     } else if (selectedCellContent !== '') {
  //       setSelectedCellContent('');
  //       console.log('setSelectedCellContent - last');
  //     }
  //   });
  // } else {
  //   if (selectedCellContent !== '') {
  //     setSelectedCellContent('');
  //   }
  // }

  const handleCsvData = (rows: Record<string, string>[], cb: () => void) => {
    sendProStudioEvent({ type: 'uploadCsvFile', payload: { rows, cb } });
  };

  return (
    <div
      test-id="ps-editor-table-controls-bar"
      className="c-editor-table-controls-bar"
    >
      {/**
      <div className="c-editor-table-controls-bar__actions c-editor-table-controls-bar__history-actions">
        <IconButton size="small" name="undo" disabled />
        <IconButton size="small" name="redo" disabled />
      </div>
      */}
      {/**
      <div className="c-editor-table-controls-bar__info">
        <span>
          <>
            {tableStore.selectedCellColumnIndex() || '?'}:
            {tableStore.selectedCellRowIndex() || '?'}
          </>
        </span>
      </div>
      */}
      <div className="c-editor-table-controls-bar__content">
        <textarea
          className="c-editor-table-controls-bar__textarea"
          onFocus={() => {
            runInAction(() => {
              tableStore.isCellBeingEdited = true;
              // Capture the value when user focuses
              setOriginalValueOnFocus(valueToRender?.toString() || '');
            });
          }}
          onChange={(e) => {
            runInAction(() => {
              tableStore.isCellBeingEdited = true;

              if (!rowId) return;
              if (!columnId) return;

              let valToUpdate: string | (string | number)[] =
                e.currentTarget.value;
              const currentRow = tableStore.rows.find(
                (row2) => row2.id === rowId
              );

              const valueMap = isJsonColumn
                ? getJsonOrderMap({ value: valToUpdate, columnId })
                : null;

              if (columnId === NodeColumns.whatsNext) {
                valToUpdate = valToUpdate.split('|');
              }
              if (
                columnId === NodeColumns.variables &&
                typeof valToUpdate === 'string'
              ) {
                valToUpdate = valToUpdate.split(',');
              }
              if (
                columnId === NodeColumns.nextNodes &&
                typeof valToUpdate === 'string'
              ) {
                valToUpdate = convertNextNodesToArray(valToUpdate);
              }

              // Update MobX store immediately (but don't save to DB)
              tableStore.updateRow({
                rowId,
                updates: {
                  ...currentRow,
                  [columnId]: valToUpdate,
                  ...(valueMap && { [`${columnId}Map`]: valueMap }),
                },
                skipValidationRules: true,
                saveImmediately: false,
              });

              // Track row as dirty
              tableStore.markRowDirty(rowId);
            });
          }}
          onBlur={() => {
            setTimeout(() => {
              runInAction(() => {
                tableStore.isCellBeingEdited = false;
              });
            }, 500);

            if (!rowId) return;

            const currentMobxValue = tableStore.selectedCellValue();

            // Only save if value actually changed from when user focused
            if (currentMobxValue?.toString() !== originalValueOnFocus) {
              tableStore.saveUnsavedChanges();
            } else {
              // Value reverted to original - just clear dirty flag
              tableStore.clearRowDirty(rowId);
            }
          }}
          style={{
            backgroundColor:
              tableStore.isSelectedCellEditable() === false
                ? 'rgb(243, 243, 243)'
                : 'transparent',
            opacity: !tableStore.isSelectedCellEditable() ? 0.5 : 1,
          }}
          disabled={!tableStore.isSelectedCellEditable()}
          // ref={inputRef}
          value={
            tableStore.isSelectedCellRenderable() === false
              ? 'Select only one cell to view'
              : valueToRender || ''
          }
        ></textarea>
      </div>
      {children && (
        <div className="c-editor-table-controls-bar__actions c-editor-table-controls-bar__row-actions">
          {children}
        </div>
      )}
      <div className="c-editor-table-controls-bar__actions c-editor-table-controls-bar__row-actions">
        <CsvUploader onData={handleCsvData} />
        <CsvDownloader />
      </div>
      {isSupervisorConfigured && !supervisorPanelOpen && (
        <div className="c-editor-table-controls-bar__actions c-editor-table-controls-bar__row-actions">
          <IconButton size="small" name="stars" onClick={openSupervisorPanel} />
        </div>
      )}
      {/**
      <div className="c-editor-table-controls-bar__actions c-editor-table-controls-bar__row-actions">
        <IconButton size="small" name="text-overflow" />
        <IconButton size="small" name="text-clip" />
        <IconButton size="small" name="text-wrap" />
      </div>
      */}
    </div>
  );
});
